// проверка на использование кириллицы при вводе фио
export const onlyCyrillic = /^[а-яА-ЯЁё\s'-]+$/;
